import { createAction, props } from '@ngrx/store';

export enum DocumentActionTypes {
    SEND_DISCLOSURE_DOCUMENT_REQUEST = '[document] - send disclosure document request',
}

export const sendDisclosureDocumentRequest = createAction(
    DocumentActionTypes.SEND_DISCLOSURE_DOCUMENT_REQUEST,
    props<{ emailAddress?: string }>(),
);
